module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/ban-d7718d0f6ba13a89c33fae7bd12349ed.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/ban.svg
// module id = r5HH
// module chunks = 24